import { combineReducers } from "redux";
import { authReducer } from "./authReducer";
import settingsReducer from "./settingsReducer";
import { paginationReducer } from "./paginationReducer";
import { uiReducer } from "./uiReducer";
import { usersReducer } from "../../module/admin/redux/reducers/usersReducer";
import { entitiesReducer } from "./entitiesReducer";
import { searchReducer } from "./searchReducer";
import { trdReducer } from "../../module/admin/redux/reducers/trdReducer";
import { correspondenceReducer } from "./correspondenceReducer";
import { documentManagmentReducer } from "./documentManagmentReducer";
import { fuidReducer } from "./fuidReducer";
import { fileModuleReducer } from "./fileModuleReducer";
import { entityLoadReducer } from "./entitiLoadReducer";
import { organizationChartReducer } from "../../module/admin/redux/reducers/organizationChartReducer";

export const rootReducer = combineReducers({
  auth: authReducer,
  setting: settingsReducer,
  pagination: paginationReducer,
  ui: uiReducer,
  users: usersReducer,
  organizationChart: organizationChartReducer,
  entities: entitiesReducer,
  search: searchReducer,
  trd: trdReducer,
  correspondence: correspondenceReducer,
  documentManagment: documentManagmentReducer,
  fuid: fuidReducer,
  fileModule: fileModuleReducer,
  entityLoad: entityLoadReducer

  // Todo: Demás Reducers
});

export type AppState = ReturnType<typeof rootReducer>;
